export default "__VITE_ASSET__Ba3SzEEc__"